import type { MouseEventHandler } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";

export interface EntityChipProps {
  className?: string;
  isSpace?: boolean;
  name: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const EntityChip = ({
  className,
  isSpace = false,
  name,
  onClick,
}: EntityChipProps) => (
  <button
    type="button"
    onClick={onClick}
    contentEditable={false}
    className={classNames(
      "text-circle mx-0.5 cursor-pointer rounded-sm bg-indigo-100 px-0.5 text-left font-medium",
      className,
    )}
  >
    {isSpace && "#"}
    {name}
  </button>
);
